import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import KPIComparator from "components/visuals/KPIComparator";

import { useAppSelector } from "store";
import { selectStore } from "modules/customer/insights/portfolio/portfolioSlice";
import { selectors } from "modules/customer/insights/portfolio/catchment/footfall";

import numberFormatter from "utils/numberFormatter";

const ChangeInFootfallLevel = () => {
    const selectedStore = useAppSelector(selectStore);
    const changeInFootfallLevel = useSelector(state => selectors.changeInFootfallLevel(state));
    const { loading, error, value, percentageDifference } = changeInFootfallLevel;
    const label = `Year-on-year (%) change in footfall through your ${selectedStore.name} store's output area vs the comparator`;
    const valueFormatted = value.toFixed(1) > 0 ? "+" + numberFormatter.toPercentage(value.toFixed(1)) : numberFormatter.toPercentage(value.toFixed(1));

    return (
        <Box width="100%" height="100%" data-cy="change-in-footfall-level">
            <KPIComparator loading={loading} error={error} label={label} value={valueFormatted} percentage={percentageDifference} />
        </Box>
    );
};

export default ChangeInFootfallLevel;
